<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ "Certificate background" }}
        </label>
      </v-system-bar>
      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <v-card
            outlined
            depressed
            width="300"
            height="60"
            style="
                      font-size: 16px;
                      border: 1px solid #c0c0c0;
                      color: #ffffff !important;
                      background-color: #a6cc39;
                    "
            class="mt-5 text-capitalize text--white rounded-lg"
          >
            <p style="color: white !important" class="text-center my-auto mt-4">
              {{ $t("certificate") }}
            </p>
          </v-card>
        </v-flex>
      </v-layout>
      <v-row>
        <v-spacer></v-spacer>
        <input
          type="file"
          class="d-none"
          ref="file"
          accept="image/*"
          @change="SelectImage($event)"
        />

        <v-btn
          outlined
          depressed
          style="
         font-size: 16px;
         border: 1px solid #c0c0c0;
         color: #ffffff !important;
         background-color: #a6cc39;"
          class="mt-5 mr-8 text-capitalize text--white rounded-lg"
          @click="$refs.file.click()"
        >
          <v-icon class="mr-2" style="color: white !important"
            >mdi-plus-box-outline</v-icon
          >
          {{ $t("addcertificate") }}
        </v-btn>
        <div></div>
      </v-row>
      <div class="ma-3 mt-2">
        <v-data-table
          :loading="loading"
          :loading-text="$t('loadingpleasewait')"
          :headers="certificate_header"
          :items="certificateItems"
          hide-default-footer
          class="editquiz-table"
          disable-pagination
        >
          <template v-slot:item.templateImage="{ item }">
            <div
              @mouseover="setHover(item.id, true)"
              @mouseleave="setHover(item.id, false)"
              style="position: relative;"
            >
              <v-img
                :src="item.templateImage"
                aspect-ratio="1"
                contain
                class="certTableImg "
                style="cursor: pointer;"
                @click.stop="openImageModal(item.templateImage)"
              />

              <v-card
                v-if="hoveredItems[item.id]"
                class="hover-card"
                style="position: absolute; top: 50%; left: 20%; transform: translate(-50%, -50%);"
              >
                <v-card-actions>
                  <v-btn
                    color="#424242"
                    style="font-size: 14px; width: 100px"
                    text
                    class="text-capitalize"
                    @click.stop="openImageModal(item.templateImage)"
                  >
                    <v-icon left>mdi-eye-outline</v-icon>
                    {{ "Preview" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <div class="onoffswitch mt-3 ml-5">
              <input
                type="checkbox"
                name="onoffswitch"
                class="onoffswitch-checkbox"
                :id="'statusOnOffSwitch-' + item.id"
                v-model="item.status"
                @change="UpdateCertStatus(item)"
              />
              <label
                class="onoffswitch-label"
                :for="'statusOnOffSwitch-' + item.id"
              >
                <div class="onoffswitch-inner"></div>
                <div class="onoffswitch-switch"></div>
              </label>
            </div>
          </template>

          <template v-slot:item.createDate="{ item }">
            {{ item.updateDate ? item.updateDate : item.createDate }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              text
              color="#FF6060"
              style="font-size: 14px"
              class="text-capitalize"
              @click="Show_DeleteCertDialog(item)"
            >
              <v-icon>mdi-delete-outline</v-icon>
              {{ $t("delete") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog
      v-model="imageModal"
      persistent
      width="800px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="imageModal = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="800px"
          height="500px"
          contain
          style="border-radius: 8px; margin: auto"
          :src="selectedImage"
        ></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteCertDialog" width="587" persistent>
      <v-card>
        <v-card-title class="justify-start">
          <p style="font-size: 30px; color: #363636">
            {{ $t("deleteconfirm") }}
          </p>
        </v-card-title>

        <v-card-text>
          <p class="pt-4 text-left" style="font-size: 16px; color: #363636">
            {{ $t("deletecertificate") }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize mb-3"
            style="
              border: 1px solid #c0c0c0;
              border-radius: 8px;
              color: #424242;
              font-size: 20px;
            "
            width="100"
            text
            @click="deleteCertDialog = false"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            width="100"
            color="#FF6060"
            style="font-size: 20px; border-radius: 8px; box-shadow: unset"
            class="text-capitalize white--text mb-3"
            @click="deleteCertificate()"
            >{{ $t("confirmsss") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
//import PrepareCertificate from "./mini-parts/PrepareCertificate.vue"
import * as moment from "moment/moment";

export default {
  components: {
    //  PrepareCertificate,
  },

  data: () => ({
    deleteCertDialog: false,
    certificateID: 0,
    imageModal: false,
    hoveredItems: {},
    hoveredImageId: null,
    showCard: false,
    selectedImage: "",
    showEditImgTool: false,
    loading: false,
    breadcrumbs: [
      {
        // image: "house.png",
        sidebar_tilte: "home"
      },
      {
        text: "quiz",
        href: "/home/quiz"
      },
      {
        text: "questionsm"
      }
    ],
    url: enurl.apiUrl,
    certificateItems: []
  }),
  computed: {
    certificate_header() {
      return [
        {
          text: this.$t("certificatebackground"),
          value: "templateImage",
          class: "tableColor",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("uploaddate"),
          align: "center",
          value: "createDate",
          class: "tableColor",
          sortable: false
          // formatter: (item) => this.formatDate(item.createDate),
        },
        {
          text: this.$t("numberofusers"),
          align: "center",
          value: "numberOfUse",
          class: "tableColor",
          sortable: false
        },

        {
          text: this.$t("status"),
          align: "center",
          tdClass: "text-right",
          value: "status",
          class: "tableColor",
          sortable: false
        },
        {
          text: this.$t("action"),
          align: "center",
          value: "actions",
          class: "tableColor",
          sortable: false
        }
      ];
    }
  },
  mounted() {
    this.GetCertificateTemplateMasterAll();
  },
  methods: {
    async UpdateCertStatus(item) {
      let that = this;
      let request = {
        id: item.id,
        status: item.status
      };
      await axios
        .post(`${that.url}Certificate/UpdateCertificateTemplateStatus`, request)
        .then(function(res) {
          if (res.data.status == 0) {
            that.GetCertificateTemplateMasterAll();
          }
        });
    },
    Show_DeleteCertDialog(item) {
      let that = this;
      that.certificateID = item.id;
      that.deleteCertDialog = true;
    },
    async deleteCertificate() {
      let that = this;
      that.loading = true;
      await axios
        .delete(
          `${that.url}Certificate/DeleteCertificateTemplate?id=` +
            that.certificateID
        )
        .then(function(res) {
          if (res.data.status == 0) {
            that.deleteCertDialog = false;
            that.certificateItems = [];
          }
        });
      that.loading = false;
      that.GetCertificateTemplateMasterAll();
    },
    setHover(itemId, isHovering) {
      this.$set(this.hoveredItems, itemId, isHovering);
    },
    openImageModal(image) {
      this.selectedImage = image;
      this.imageModal = true;
    },
    SelectImage(e) {
      let self = this;
      let file = e.target.files[0];

      // Validate file type
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose an image!");
        return false;
      }

      let reader = new FileReader();
      reader.onload = function(f) {
        let data;
        if (typeof f.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          data = f.target.result;
        }

        self.uploadImageAPI(data, file.name);
      };

      // Read file as a Data URL (base64)
      reader.readAsDataURL(file);
    },

    async uploadImageAPI(imgFile, name) {
      if (!imgFile) return "";

      try {
        await axios
          .post(`${this.url}File/UploadFileStringBase`, {
            base64: imgFile,
            fileName: name
          })
          .then(response => {
            // Changed to arrow function
            this.AddCertBackgroundTemplate(response.data); // Now this refers to the Vue component
          });
      } catch (error) {
        console.error("Error uploading image: ", error);
        return "";
      }
    },

    async AddCertBackgroundTemplate(value) {
      if (value === null) {
        alert("Null Image data!");
        return;
      }
      try {
        await axios
          .post(
            `${this.url}Certificate/AddCertificateTemplate?imageUrl=` + value
          )
          .then(response => {
            if (response.data.status === 0) {
              this.GetCertificateTemplateMasterAll();
            }
          });
      } catch (error) {
        console.error("Something went wrong: ", error);
        return "";
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    },

    async GetCertificateTemplateMasterAll() {
      let self = this;
      self.loading = true;
      axios
        .get(`${self.url}Certificate/GetTemplateImageMasterTable`)
        .then(response => {
          self.certificateItems = response.data.data.reverse().map((v, i) => ({
            ...v,
            createDate: v.createDate ? self.formatDate(v.createDate) : null,
            updateDate: v.updateDate ? self.formatDate(v.updateDate) : null
          }));
          console.log("self.certificateItems", self.certificateItems);
          self.loading = false;
        })
        .catch(function(error) {
          alert(error);
        });
    }
  }
};
</script>
<style scoped>
.v-application .text-center {
  text-align: center !important;
}
.tableColor {
  text-align: center; /* Centering text */
}
::v-deep .preview_class.v-dialog {
  border-radius: 8px !important;
}
.hover-card {
  /* Additional styles for the hover card */
  transition: opacity 0.3s;
}
/* .certTableImg { */
/* position: relative; Needed for absolute positioning of card */
/* } */
.certTableImg {
  /* text-align: center !important; */

  margin: 10px 0px;
  border-radius: 5px;
  height: 285px;
  width: 175px !important;
}
.onoffswitch {
  position: relative;
  width: 73px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}
.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
}
.onoffswitch-inner {
  width: 200%;
  margin-left: -100%;
  -moz-transition: margin 0.3s ease-in 0s;
  -webkit-transition: margin 0.3s ease-in 0s;
  -o-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
  float: left;
  width: 50%;
  height: 28px;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "ON";
  padding-left: 0;
  padding-right: 30px;
  background-color: #6fdc42;
  color: #ffffff;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 11px;
  color: #ffffff;
  background-color: #707070;
  opacity: 1;
  text-align: right;
}
.onoffswitch-switch {
  width: 26px;
  height: 26px;
  margin: 1px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 44px;
  -moz-transition: all 0.3s ease-in 0s;
  -webkit-transition: all 0.3s ease-in 0s;
  -o-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}
.articleimg {
  margin: 10px 0px;
  border-radius: 20px;
  height: 135px;
  width: 250px !important;
}
::v-deep .editquiz-table tr:nth-child(even) {
  background: #e0e0e0;
  margin-top: 0.5rem;
}
::v-deep .editquiz-table .v-input--selection-controls__input .v-icon {
  color: #a6cc39 !important;
  border-radius: 4px;
  opacity: 1;
}
::v-deep .editquiz-table.v-data-table {
  max-width: 100%;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 14px !important;
  color: #424242 !important;
  opacity: 1;
}
::v-deep .editquiz-table.v-data-table {
  max-width: 100%;
}
::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
} /**.child_table */
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 14px !important;
  color: #424242 !important;
  opacity: 1;
  text-align: center;
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
}
</style>
